// src/page/KlarnaReturn.tsx
import { useEffect, useRef, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "react-toastify";
import { useDraftManager } from "../../hooks/useDraftManager";

const KlarnaReturn = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { fetchDrafts, loadDraft } = useDraftManager();
  const hasProcessed = useRef(false);
  const [isLoading, setIsLoading] = useState(true);
  const [loadingMessage, setLoadingMessage] = useState("Traitement de votre paiement Klarna en cours...");

  useEffect(() => {
    // Éviter le double appel en développement (React StrictMode)
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const handleKlarnaReturn = async () => {
      const paymentIntent = searchParams.get("payment_intent");
      const redirectStatus = searchParams.get("redirect_status");

      console.log("🔍 Retour Klarna:", { paymentIntent, redirectStatus });

      if (!paymentIntent) {
        toast.error("Référence de paiement manquante");
        navigate("/home/draft");
        return;
      }

      // Gérer les différents statuts
      switch (redirectStatus) {
        case "succeeded":
          setLoadingMessage("Paiement confirmé ! Redirection...");
          toast.success("Paiement Klarna confirmé !");

          // Petit délai pour que le webhook ait le temps de traiter
          setTimeout(() => {
            navigate("/home/gestion-annonces");
          }, 1500);
          break;

        case "canceled":
        case "failed":
          const message = redirectStatus === "canceled"
            ? "Redirection vers la création d'annonce..."
            : "Redirection vers la création d'annonce...";

          setLoadingMessage(message);
          toast.warning(message);

          console.log("🔄 Redirection vers création d'annonce avec payment_intent...");

          // Redirection simple vers la page de création d'annonce
          // NouvelleAnnonce gérera la restauration via getAnnonceTemp
          setTimeout(() => {
            navigate(`/home/nouvelle-annonce?payment_intent=${paymentIntent}&redirect_status=${redirectStatus}`, {
              replace: true
            });
            setIsLoading(false);
          }, 1500);
          
          break;

        default:
          console.log("⏳ Statut inconnu ou en attente:", redirectStatus);
          setLoadingMessage("Vérification du statut du paiement...");
          toast.info("Traitement du paiement en cours...");

          // Attendre un peu le webhook
          setTimeout(() => {
            navigate("/home/gestion-annonces");
          }, 3000);
      }
    };

    handleKlarnaReturn();
  }, [navigate, searchParams, fetchDrafts, loadDraft]);

  return (
    <div style={{
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      height: "100vh",
      flexDirection: "column",
      backgroundColor: "#f8f9fa",
      padding: "20px"
    }}>
      <div
        className="spinner-border text-primary"
        role="status"
        style={{
          width: "3rem",
          height: "3rem",
          borderWidth: "0.3rem"
        }}
      >
        <span className="visually-hidden">Traitement en cours...</span>
      </div>
      <p style={{
        marginTop: "20px",
        fontSize: "18px",
        color: "#495057",
        fontWeight: "500",
        textAlign: "center"
      }}>
        {loadingMessage}
      </p>
      <p style={{
        marginTop: "10px",
        fontSize: "14px",
        color: "#6c757d",
        textAlign: "center"
      }}>
        Veuillez patienter, ne fermez pas cette page.
      </p>
    </div>
  );
};

export default KlarnaReturn;